import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-introduce',
  templateUrl: './home-introduce.component.html',
  styleUrls: ['./home-introduce.component.scss'],
})
export class HomeIntroduceComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
